import { Col } from "react-grid-system";
import DetailsRow from "../../DetailsRow";
import { CsrDataPanel } from "../../../lib/api/models";
import styles from "./DataPanelContent.module.css";
import {
  convertDateStringToMonthDayYearFormat,
  convertYearMonthDateStringToMonthYearFormat,
  validateBeforeCentsToDollarString,
} from "../../../lib/formatting";

const strings = {
  behaviorCreditBureauScore: "Score BH/CB",
  fraudSuspStrategy: "Frd Susp Strat",
  fraudSuspStrategyDate: "Frd Susp Strat Dt",
  lastPINChangeDate: "Last PIN Chng Dt",
  pinTries: "PIN Tries",
  lostStolenDate: "Lost or Stolen Dt",

  cashAdvanceOut: "Cash Adv Out",
  lastCashAdvanceAmountCents: "Last Cash Adv Amt",
  lastCashAdvanceDate: "Last Cash Adv Dt",
  creditLineLastChangeDate: "CL Last Chng Dt",
  creditLinePrevChangeDate: "CL Prev Chng Dt",
  creditLineReviewDate: "CL Rvw Dt",

  lastCreditLineChange: "Last CL Chng",
  fdrACHSkip: "FDR ACH Skip",
  numberOfCards: "# of Cards",
  cardType: "Card Type",
  lastCardOrderedDate: "Last Card Ord Dt",
  expirationDate: "Expiration Dt",

  months123Delinquent: "#1mo/2mo/3mo Delq",
  overlimitHistory: "Overlimit History",
  ocl10PercentOrGreater: "OCL 10%",
  firstUtilizeDate: "First Utilize Dt",
  lastLetterMailedID: "Last Ltr Maild ID",
  lastLetterMailedDate: "Last Ltr Mailed Dt",

  sourceCode: "Source Cd",
  payAhead: "Pay Ahead",
  marketingInfo: "Marketing Info",
};

export default function CustomerServiceInnerContent(data: CsrDataPanel) {
  return (
    <>
      <Col xs={2}>
        <DetailsRow
          className={styles.detailsRow}
          label={strings.behaviorCreditBureauScore}
          value={data.behaviorCreditBureauScore}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.fraudSuspStrategy}
          value={data.fraudSuspStrategy}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.fraudSuspStrategyDate}
          value={convertDateStringToMonthDayYearFormat(
            data.fraudSuspStrategyDate,
          )}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lastPINChangeDate}
          value={convertDateStringToMonthDayYearFormat(data.lastPINChangeDate)}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.pinTries}
          value={data.pinTries}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lostStolenDate}
          value={convertDateStringToMonthDayYearFormat(data.lostStolenDate)}
        />
      </Col>
      <Col xs={2}>
        <DetailsRow
          className={styles.detailsRow}
          label={strings.cashAdvanceOut}
          value={validateBeforeCentsToDollarString(data.cashAdvanceOut, true)}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lastCashAdvanceAmountCents}
          value={validateBeforeCentsToDollarString(
            data.lastCashAdvanceAmountCents,
            true,
          )}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lastCashAdvanceDate}
          value={convertDateStringToMonthDayYearFormat(
            data.lastCashAdvanceDate,
          )}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.creditLineLastChangeDate}
          value={convertYearMonthDateStringToMonthYearFormat(
            data.creditLineLastChangeDate,
          )}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.creditLinePrevChangeDate}
          value={convertYearMonthDateStringToMonthYearFormat(
            data.creditLinePrevChangeDate,
          )}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.creditLineReviewDate}
          value={convertYearMonthDateStringToMonthYearFormat(
            data.creditLineReviewDate,
          )}
        />
      </Col>
      <Col xs={2}>
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lastCreditLineChange}
          value={data.lastCreditLineChange}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.fdrACHSkip}
          value={data.fdrACHSkip}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.numberOfCards}
          value={data.numberOfCards.toString()}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.cardType}
          value={data.cardType}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lastCardOrderedDate}
          value={convertDateStringToMonthDayYearFormat(
            data.lastCardOrderedDate,
          )}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.expirationDate}
          value={data.expirationDate}
        />
      </Col>
      <Col xs={2}>
        <DetailsRow
          className={styles.detailsRow}
          label={strings.months123Delinquent}
          value={data.months123Delinquent}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.overlimitHistory}
          value={data.overlimitHistory.toString()}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.ocl10PercentOrGreater}
          value={data.ocl10PercentOrGreater}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.firstUtilizeDate}
          value={convertDateStringToMonthDayYearFormat(data.firstUtilizeDate)}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lastLetterMailedID}
          value={data.lastLetterMailedID}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.lastLetterMailedDate}
          value={convertDateStringToMonthDayYearFormat(
            data.lastLetterMailedDate,
          )}
        />
      </Col>
      <Col xs={2}>
        <DetailsRow
          className={styles.detailsRow}
          label={strings.sourceCode}
          value={data.sourceCode}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.payAhead}
          value={data.payAhead}
        />
        <DetailsRow
          className={styles.detailsRow}
          label={strings.marketingInfo}
          value={data.marketingInfo}
        />
      </Col>
    </>
  );
}
